import { render, staticRenderFns } from "./peopleCompileUser.vue?vue&type=template&id=7526b7fc&scoped=true"
import script from "./peopleCompileUser.vue?vue&type=script&lang=js"
export * from "./peopleCompileUser.vue?vue&type=script&lang=js"
import style0 from "./peopleCompileUser.vue?vue&type=style&index=0&id=7526b7fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7526b7fc",
  null
  
)

export default component.exports